import { Box, Button, FormControl, FormHelperText, Grid, IconButton, useMediaQuery, MenuItem, TextField, Typography, styled } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import { useEffect, useState } from "react";
import { isValidEmail, isValidPhoneNumber, phoneNumberFormatter } from "../../libs/utils";
import { getZipCodes, states, whichStates } from "./utils";
import PhoneVerifyModal from "./PhoneVerifyModal";

export const StyledTextField = styled(TextField)({
    width: "100%", 
    backgroundColor: "white",
    fontSize: "16px"
})

export const validateZipCode = (zipCode, state) => {

    const statesArr = whichStates(zipCode)
    if (statesArr.findIndex((s) => s === state) === -1) {
        return true
    }

    const targetCodes = getZipCodes(state)

    return targetCodes.findIndex((c) => c === zipCode) === -1
}

const SecondRegisterStepV2 = ({registrationForm, setRegistrationForm, handleRegistrationFormChange, workAddress, setWorkAddress, companyInfo, setCompanyInfo, handleNext }) => {

    const { distributorId, organizationName, agentId } = companyInfo
    const { workAgentPhone } = registrationForm
    const { address1, address2, city, state, zipCode } = workAddress

    const [showPhoneVerifyModal, setShowPhoneVerifyModal] = useState(false)
    const [errorTree, setErrorTree] = useState({
        phoneNumber: false,
        zipCode: false,
        address1: false,
        city: false,
        state: false,
      })

      const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

      useEffect(() => {
        if(zipCode === '' && !state) return setErrorTree((prev) => ({ ...prev, zipCode: false }))
        if (zipCode !== '' && zipCode.length < 5) {
          setErrorTree((prev) => ({ ...prev, zipCode: true }))
          return
        }
   
        if(state) {
          const isValid = validateZipCode(zipCode, state)
          setErrorTree((prev) => ({ ...prev, zipCode: isValid }))
        }
        
      }, [state, zipCode])

      const handleSubmit = () => {

        handleNext();
      }

      const handleBlur = ({ target: { name, value } }) => {
        switch (name) {
          case 'address2':
            break
          case 'workAgentPhone':
            setErrorTree((prev) => ({
              ...prev,
              phoneNumber: !isValidPhoneNumber(value),
            }))
            break
          default:
            setErrorTree((prev) => ({ ...prev, [name]: value.trim() === '' }))
            break
        }
      }
    

    return (
      <Box width={'100%'}>
        <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
          Company Information
        </Typography>
        <Grid container spacing={3} justifyContent={'flex-start'} alignItems={'flex-start'}>
          <Grid item xs={12} md={6}>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. 000000000"
              className="white-box"
              label="Distributor ID"
              disabled
              value={distributorId}
              name="distributorId"
              onChange={(e) => setCompanyInfo({ ...companyInfo, [e.target.name]: e.target.value })}
              // focused={firstName !== ""}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. Lorem Co."
              label="Organization Name"
              disabled
              value={organizationName}
              name="organizationName"
              onChange={(e) => setCompanyInfo({ ...companyInfo, [e.target.name]: e.target.value })}
              // focused={lastName !== ""}
            />
          </Grid>
          <Grid item xs={12} md={10}>
            <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
              Contact Information
            </Typography>
            <FormControl fullWidth>
              <StyledTextField
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    '&.MuiInputLabel-shrink': {
                      backgroundColor: '#F5F7FF',
                    },
                  },
                }}
                placeholder="ex. 000-000-0000"
                className="white-box"
                label="Work Phone Number"
                value={workAgentPhone}
                name="workAgentPhone"
                type="number"
                onBlur={handleBlur}
                error={errorTree.phoneNumber}
                onChange={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
                // inputProps={{ maxLength: 10 }}
              />
            </FormControl>
            {errorTree.phoneNumber && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    Please enter a valid phone number
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} md={2}>
            <Box display="flex" paddingTop={{ sm: '2.9rem', xs: '0' }}>
              {/* <Button
                sx={{
                  textTransform: 'none',
                  width: { lg: '90%', md: '90%', sm: '90%', xs: '100%' },
                  height: '40px',
                  backgroundColor: '#C4CAF1',
                  color: '#3C4FB9',
                  borderRadius: '100px',
                  '&:hover': {
                    backgroundColor: '#9BA5DF',
                    color: '#36414E',
                  },
                  '&:disabled': {
                    backgroundColor: '#C4CAF1',
                    color: 'white',
                    textTransform: 'none',
                  },
                }}
                onClick={() => setShowPhoneVerifyModal(true)}
              >
                Verify
              </Button> */}
            </Box>
          </Grid>
          {/* <Grid item xs={12}>
            <Typography
              style={{
                fontSize: '12px',
                color: '#56677B',
              }}
              textAlign={'start'}
            >
              By verifying your phone number, you consent to receive SMS to verify your identity. There may be a charge
              depending on the carrier.
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <Typography color="#00314D" fontSize={'16px'} mb={2} textAlign={'start'}>
              Work Address
            </Typography>
            <FormControl fullWidth>
              <StyledTextField
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    '&.MuiInputLabel-shrink': {
                      backgroundColor: '#F5F7FF',
                    },
                  },
                }}
                placeholder="ex. 02139"
                label="Zip Code"
                name="zipCode"
                value={zipCode}
                type="number"
                error={errorTree.zipCode}
                onChange={(e) => setWorkAddress({ ...workAddress, [e.target.name]: e.target.value })}
                inputProps={{ maxLength: 5 }}
              />
            </FormControl>
            {errorTree.zipCode && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    Invalid zip code
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <StyledTextField
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    '&.MuiInputLabel-shrink': {
                      backgroundColor: '#F5F7FF',
                    },
                  },
                }}
                placeholder="ex. 1234 Chance Rd. "
                className="white-box"
                label="Address 1"
                fullWidth
                name="address1"
                value={address1}
                onBlur={handleBlur}
                error={errorTree.address1}
                onChange={(e) => setWorkAddress({ ...workAddress, [e.target.name]: e.target.value })}
              />
            </FormControl>
            {errorTree.address1 && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    Address 1 is required
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              InputLabelProps={{
                shrink: true,
                sx: {
                  '&.MuiInputLabel-shrink': {
                    backgroundColor: '#F5F7FF',
                  },
                },
              }}
              placeholder="ex. apt 111"
              className="white-box"
              label="Address 2"
              fullWidth
              name="address2"
              value={address2}
              onChange={(e) => setWorkAddress({ ...workAddress, [e.target.name]: e.target.value })}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <StyledTextField
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    '&.MuiInputLabel-shrink': {
                      backgroundColor: '#F5F7FF',
                    },
                  },
                }}
                placeholder="ex. Miami"
                className="white-box"
                label="City"
                fullWidth
                name="city"
                value={city}
                error={errorTree.city}
                onBlur={handleBlur}
                onChange={(e) => setWorkAddress({ ...workAddress, [e.target.name]: e.target.value })}
              />
            </FormControl>
            {errorTree.city && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    City is required
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <StyledTextField
                select
                InputLabelProps={{
                  shrink: true,
                  sx: {
                    '&.MuiInputLabel-shrink': {
                      backgroundColor: '#F5F7FF',
                    },
                  },
                }}
                className="white-box"
                label="State"
                fullWidth
                name="state"
                value={state}
                error={errorTree.state}
                onBlur={handleBlur}
                onChange={(e) => setWorkAddress({ ...workAddress, [e.target.name]: e.target.value })}
              >
                <MenuItem value={null} defaultChecked>
                  Select State
                </MenuItem>
                {states.map((state, index) => (
                  <MenuItem key={index} value={state}>
                    {state}
                  </MenuItem>
                ))}
              </StyledTextField>
            </FormControl>
            {errorTree.state && (
              <FormHelperText>
                <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                  <ErrorIcon sx={{ fontSize: '0.8rem !important', color: '#CA303A' }} />
                  <Typography fontSize={'12px'} color="#CA303A">
                    State is required
                  </Typography>
                </div>
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button
              sx={{
                textTransform: 'none',
                width: { lg: '20%', md: '20%', sm: '50%', xs: '60%' },
                height: '40px',
                backgroundColor: '#3C4FB9',
                color: 'white',
                borderRadius: '100px',
                mt: '10px',
                '&:hover': {
                  backgroundColor: '#9BA5DF',
                  color: '#36414E',
                },
                '&:disabled': {
                  backgroundColor: '#C4CAF1',
                  color: 'white',
                  textTransform: 'none',
                },
              }}
              onClick={handleSubmit}
            >
              {isMobile ? 'Done' : 'Next'}
            </Button>
          </Grid>
        </Grid>
        <PhoneVerifyModal
          show={showPhoneVerifyModal}
          setShow={setShowPhoneVerifyModal}
          phone={workAgentPhone}
          setRegistrationForm={(e) => setRegistrationForm({ ...registrationForm, [e.target.name]: e.target.value })}
          phoneError={errorTree.phoneNumber}
          handlePhoneBlur={handleBlur}
        />
      </Box>
    )
}

export default SecondRegisterStepV2;